import { Modal } from "antd";
import React from "react";
import TemplatePreview from "./TemplatePreview";

const TemplatePreviewModal = ({ isOpen, onClose, selectedTemplate }) => {
  return (
    <Modal
      footer={null}
      title={"Preview"}
      open={isOpen}
      styles={{
        content: {
          padding: 0,
          paddingInline: 5,
          paddingBlock: 0,
          paddingBottom: 10,
        },
        header: {
          borderBottom: "1px solid #E8E8EA",
          paddingBlock: 10,
          paddingInline: 15,
        },
      }}
      onCancel={onClose}
      width={300}
    >
      <TemplatePreview selectedTemplate={selectedTemplate} />
    </Modal>
  );
};

export default TemplatePreviewModal;
